import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const siteName = ref('ClearRand')
  const siteUrl = ref(import.meta.env.VITE_SITE_URL || 'https://example.co.za')
  const taxYear = ref('2027')
  const currency = ref('ZAR')
  const debug = ref(import.meta.env.DEV)

  return { siteName, siteUrl, taxYear, currency, debug }
})
